export default __webpack_public_path__ + "static/media/life_Insurance-bank_account_page.0310ac37.pdf";